import SigninComp from "../../components/Login/Signin";
import "./SignIn.scss"

const SignIn = () => {
  return (
    <div className="signIn">
      <SigninComp />
    </div>
  );
};

export default SignIn;
